import { render, staticRenderFns } from "./permissions-toggle.vue?vue&type=template&id=8251f5f0&scoped=true&"
import script from "./permissions-toggle.vue?vue&type=script&lang=js&"
export * from "./permissions-toggle.vue?vue&type=script&lang=js&"
import style0 from "./permissions-toggle.vue?vue&type=style&index=0&id=8251f5f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8251f5f0",
  null
  
)

export default component.exports